<template>
  <footer class="hw-footer">
    <div class="hw-footer-bg"></div>
    <div class="hw-footer-socials">
      <a
        v-show="t('footer.jumpLink.fb')"
        class="hw-footer-social-icon hw-footer-social-icon--facebook-1"
        :href="t('footer.jumpLink.fb')"
        target="_blank"
        aria-label="Facebook"
      ></a>
      <a
        v-show="t('footer.jumpLink.fbGroup')"
        class="hw-footer-social-icon hw-footer-social-icon--facebook-2"
        :href="t('footer.jumpLink.fbGroup')"
        target="_blank"
        aria-label="Facebook Group"
      ></a>
      <a
        v-show="t('footer.jumpLink.dc')"
        class="hw-footer-social-icon hw-footer-social-icon--discord"
        :href="t('footer.jumpLink.dc')"
        target="_blank"
        aria-label="Discord"
      ></a>
      <a
        v-show="t('footer.jumpLink.yt')"
        class="hw-footer-social-icon hw-footer-social-icon--youtube"
        :href="t('footer.jumpLink.yt')"
        target="_blank"
        aria-label="YouTube"
      ></a>
      <a
        v-show="t('footer.jumpLink.tt')"
        class="hw-footer-social-icon hw-footer-social-icon--tiktok"
        :href="t('footer.jumpLink.tt')"
        target="_blank"
        aria-label="TikTok"
      ></a>
    </div>
    <div class="hw-footer-links">
      <span>{{ t('halloween.footer.privacyPolicy') }}</span>
      <span class="hw-footer-divider"></span>
      <span>{{ t('halloween.footer.userAgreement') }}</span>
    </div>
    <div class="hw-footer-service">
      {{ t('halloween.footer.customerService') }}
    </div>
  </footer>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<style lang="less" scoped>
.hw-footer {
  position: relative;
  width: 750px;
  height: 350px;
  margin-top: auto;
  overflow: hidden;
  color: #fff;
}

.hw-footer-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 750px;
  height: 350px;
  background: #000;
}

.hw-footer-socials {
  position: absolute;
  top: 48px;
  left: 0;
  width: 750px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 50px;
}

.hw-footer-social-icon {
  display: block;
  flex: 0 0 100px;
  width: 100px;
  height: 100px;
  background-position: center;
  background-repeat: no-repeat;

  &--facebook-1 {
    background-image: url('~@/assets/imgs/act/ann2026/footer/facebook-1.png');
    background-size: 100px 100px;
  }

  &--facebook-2 {
    background-image: url('~@/assets/imgs/act/ann2026/footer/facebook-2.png');
    background-size: 100px 100px;
  }

  &--discord {
    background-image: url('~@/assets/imgs/act/ann2026/footer/discord.png');
    background-size: 100px 100px;
  }

  &--youtube {
    background-image: url('~@/assets/imgs/act/ann2026/footer/youtube.png');
    background-size: 100px 75px;
  }

  &--tiktok {
    background-image: url('~@/assets/imgs/act/ann2026/footer/tiktok.png');
    background-size: 100px 100px;
  }
}

.hw-footer-links {
  position: absolute;
  top: 198px;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 48px;
  color: #777;
  font-size: 22px;
  line-height: 30px;
  white-space: nowrap;
}

.hw-footer-divider {
  width: 1px;
  height: 28px;
  background: #777;
}

.hw-footer-service {
  position: absolute;
  top: 249px;
  left: 25px;
  width: 700px;
  color: #fff;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
}
</style>
